
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface SecurityTypeInputProps {
  value: string;
  onChange: (value: string) => void;
}

const SecurityTypeInput = ({ value, onChange }: SecurityTypeInputProps) => {
  return (
    <div>
      <Label>Security Type</Label>
      <RadioGroup
        value={value}
        onValueChange={onChange}
        className="mt-2 space-y-2"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="men" id="security-men" />
          <Label htmlFor="security-men">Security Men</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="cctv" id="security-cctv" />
          <Label htmlFor="security-cctv">CCTV</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="na" id="security-na" />
          <Label htmlFor="security-na">NA</Label>
        </div>
      </RadioGroup>
    </div>
  );
};

export default SecurityTypeInput;
